import { Component } from '@angular/core';

@Component({
  selector: 'app-group-bar-chart-skeleton',
  templateUrl: './group-bar-chart-skeleton.component.html',
  styleUrls: ['./group-bar-chart-skeleton.component.scss'],
})
export class GroupBarChartSkeletonComponent {
  widgets = [1, 2, 3, 4];
}
